const userSignInActionPrefix = '@user-sign-in/';

/* List of Redux constants */
export const USER_SIGN_IN_RESET_STATE = `${userSignInActionPrefix}reset-state`
export const USER_SIGN_IN_SET_SIGN_IN_EMAIL = `${userSignInActionPrefix}set-sign-in-email`;


// WEBPACK FOOTER //
// ./src/actions/user-sign-in/types.js